interface StudentData {
    id?: number;
    first_name: string;
    family_name: string;
    email: string;
    wants_emails?: boolean;
}

class Student {
    id?: number;
    first_name: string;
    family_name: string;
    email: string;
    wants_emails: boolean;

    constructor(data: StudentData) {
        this.id = data.id;
        this.first_name = data.first_name;
        this.family_name = data.family_name;
        this.email = data.email;
        this.wants_emails = data.wants_emails ?? true;
    }

    // Computed property to get full name
    get name(): string {
        return `${this.first_name} ${this.family_name}`;
    }

    // Static method to create a Student instance from raw API data
    static fromApiData(data: any): Student {
        return new Student({
            id: data.id,
            first_name: data.first_name,
            family_name: data.family_name,
            email: data.email,
            wants_emails: data.wants_emails
        });
    }

    // Static method to create multiple Student instances from raw API data
    static fromApiDataArray(dataArray: any[]): Student[] {
        return dataArray.map(data => Student.fromApiData(data));
    }
}

export default Student; 